module.exports = __webpack_public_path__ + "img/H1.c42984d8.png";